<template>
  <html>

  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <link rel="icon" type="image/png" href="favicon.png" />
    <title>Restó APP</title>
  </head>

  <body class="home-page">
    <Header :isRestoCompleto=true ></Header>
    <div class="col-lg-8 mx-auto p-3 py-md-5">
      <main>
        <h3>Reserva Manual</h3>

        <hr class="" />

        <form v-on:submit.prevent="reservar">
          <div class="form-group mb-3">
            <label class="form-label">Nombre</label><input v-model="nombre" type="text" class="form-control" />
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Apellido</label><input v-model="apellido" type="text" class="form-control" />
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Email</label><input v-model="email" type="text" class="form-control" />
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Teléfono</label><input v-model="telefono" type="text" class="form-control" />
          </div>
          <div class="mb-4 row">
            <label class="col-sm-3 col-form-label">Comensales</label>
            <div class="col-sm-3">
              <label class="form-label">Mayores</label>
              <select class="form-control" formControlName="mayores" v-model="cantidad_mayor" @change="comensales()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
              </select>
            </div>
            <div class="col-sm-3">
              <label class="form-label">Menores</label>
              <select class="form-control" formControlName="menores" v-model="cantidad_menor" disable="disabled_menores"
                @change="comensales()">
                <option v-for="(menor, index) in menores" :key="index">
                  {{ menor }}
                </option>
              </select>
            </div>
          </div>


          <div class="row">

            <div class="col-6" >
            <label class="form-label"> Fecha: </label>
          <div class="form-group">
            <date-picker v-model="fecha" valueType="format" format="DD-MM-YYYY" @change="setHorarios()" :disabled-date="disabledRange" :disabled="cantidad_mayor=='' || cantidad_menor==null" >
            </date-picker>


          </div>
            
        </div>

        <div class="col-3">

            <label class="form-label">Hora</label>


            <select class="form-control form-group mb-3" formControlName="hora" v-model="horaSeleccionada"
         :disabled="cantidad_mayor=='' || cantidad_menor==null || fecha==''"
         @change="handleTimeChange"
         >
                <option v-for="(horario, index) in horarios" :key="index">
                  {{ horario.horario }}
                </option>
              </select>
          </div>

          <div class="col-3">

<label class="form-label">Minutos</label>


<select class="form-control form-group mb-3" formControlName="hora" v-model="minutosSeleccionados"
:disabled="cantidad_mayor=='' || cantidad_menor==null || fecha==''"
>
    <option v-for="(minuto, index) in minutos" :key="index">
      {{ minuto }}
    </option>
  </select>
</div>

        </div>



          <button type="submit" class="w-100 mb-3 btn btn-primary btn-lg">
            Guardar
          </button>
        </form>
        <PopUp :show="success" @close="success = false">
          <template #body>
            <p style="white-space: pre-line;">{{ success_msg }}</p>
          </template>
        </PopUp>
        <PopUp :show="error" @close="error = false">
          <template #body>
            <p>{{ error_msg }}</p>
          </template>
        </PopUp>

        <PopUpEntendido :show="successentenedio" @close="successentenedio = false;volverAlInicio()">
          <template #body>
            <p>{{ success_entenedio_msg  }}</p>
          </template>
        </PopUpEntendido>


        <Footer />
      </main>
    </div>
  </body>

  </html>
</template>

<script>
import Header from "../components/Header.vue";
import axios from "axios";
import Footer from "../components/Footer.vue";
import PopUp from "../components/PopUp.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import PopUpEntendido from "../components/PopUpEntendido.vue";

export default {
  name: "ReservaManual",
  components: { PopUp, Header, Footer, DatePicker,PopUpEntendido },
  data: function () {
    return {
      nombre: "",
      apellido: "",
      email: "",
      telefono: "",
      horario: "",
      horarios: [],
      fecha: "",
      cantidad_mayor: "",
      cantidad_menor: "",
      horaSeleccionada:null,
      horas:[],
      menores: [],
      error: false,
      success: false,
      error_msg: "",
      success_msg: "",
      terminos: [],
      disabledBefore: new Date(),
      minutos:[],
      minutosSeleccionados:null,
      success_entenedio_msg:"",
      successentenedio:false, 
    };
  },

  methods: {
    handleTimeChange() {
      let tempMinutos = this.horarios.find(h => h.horario == this.horaSeleccionada);
      console.log(tempMinutos)
      if(tempMinutos){
        this.minutos=tempMinutos.minutos
      }

    },
    disabledRange: function (date) {
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
         return date <= new Date();
     },
     volverAlInicio() {
      this.$router.push({ name: "inicio"});
    },
    comensales() {
      if (this.cantidad_mayor != null) {
        this.menores = [];
        this.disabled_menores = false;

        for(let i=0; i <= (6-parseInt(this.cantidad_mayor)); i++){
          this.menores.push(i);
        }
        if (!this.menores.includes(Number.parseFloat(this.cantidad_menor))) {
          this.cantidad_menor = null;
        }
      }
    },
    setHorarios() {

      if (
        this.cantidad_mayor != null &&
        this.cantidad_menor != null &&
        this.fecha != null
      ) {
        axios
          .get(
            "/horarios/" +
            this.fecha +
            "/" +
            this.cantidad_mayor +
            "/" +
            this.cantidad_menor
          )
          .then((data) => {
            if (data.data.descripcionError == null) {
              this.horarios = data.data.horarios;
              let fechaHoy = new Date();
              let fechaSeleccionada = new Date(this.fecha.replace(/(..)-(..)-(....)/, '$3-$2-$1 12:00'));
              if(
                fechaSeleccionada.getDate() == fechaHoy.getDate() &&
                fechaSeleccionada.getMonth() == fechaHoy.getMonth() &&
                fechaSeleccionada.getFullYear() == fechaHoy.getFullYear()
              ) {
                let horaActual = fechaHoy.getHours();
                for(let i = 0; i < this.horarios.length; i++) {
                  if(this.horarios[i] <= horaActual) {
                    this.horarios[i] = null;
                  }
                }
                this.horarios = this.horarios.filter(val=>val);
              }
            } else {
              this.error = true;
              this.error_msg = data.data.descripcionError;
              this.disabled_horarios = true;
            }
            if (this.horarios.length > 0) {
              this.disabled_horarios = false;
            } else {
              this.disabled_horarios = true;
              this.error = true;
              this.error_msg = "No hay horarios disponibles para esta fecha";
            }
          });
      } else {
        this.horarios = [];
        this.disabled_horarios = true;
      }
    },
    goToPage(page) {
      this.$router.push({ name: page });
    },
    limpiarFormulario(){

      this.nombre = "";
      this.apellido = "";
      this.email = "";
      this.telefono = "";
      this.horaSeleccionada = "";
      this.minutosSeleccionados = "";
      this.fecha = "";

    },
    reservar() {

      

      this.error_msg = "";
      if (
        this.nombre == "" ||
        this.apellido == "" ||
        this.email == "" ||
        this.telefono == "" ||
        this.horaSeleccionada == null ||
        this.horaSeleccionada == "" ||
        this.minutosSeleccionados == null ||
        this.minutosSeleccionados == "" ||
        this.fecha == ""
      ) {
        this.error = true;
        this.error_msg = "Completa todos los campos por favor";
        return;
      }

      let json = {
        nombre: this.nombre,
        apellido: this.apellido,
        email: this.email,
        telefono: this.telefono,
        fecha: this.fecha,
        horario: this.horaSeleccionada+":"+this.minutosSeleccionados,
        cantidad_mayor: this.cantidad_mayor,
        cantidad_menor: this.cantidad_menor

      };
      axios
        .post("/reservarManual", json)
        .then((data) => {
          if (data.data.error == null) {

            this.success = true;
            this.success_msg =  ` Reserva confirmada con exito.
             El numero asignado a la reserva es:  ${data.data.reserva_id}
             Enviaremos copia de la reserva por correo. 
              ` ;

              this.successentenedio = true;
              this.success_entenedio_msg = "Felicitaciones! Ha ingresado una nueva reserva manual.";       

              this.limpiarFormulario();
              /* setTimeout(() => {
                this.$router.push({ name: "inicio"});
              }, 7000); */


          } else {
            this.error = true;
            this.error_msg = data.data.error;
          }
        })
        .catch((e) => {
          this.error = true;
          if (e.request.status == 400) {
            this.error_msg = "No se ha podido realizar la reserva";
          } else {
            this.error_msg = "No se ha podido realizar la reserva";
          }
        });
    },
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:root {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}

body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
</style>
